module.exports = __webpack_public_path__ + "media/message.db16ca45.mp3";